import Axios from "axios";
const CLIENTES = "/Dealers";
const DEALER_STATUS = "/Dealers/Bloquear";
const PLANES = "/planes/getPlanes";
const PLANES_ADMIN = "/planes/GetPlanAdmin";
const PLANES_SET = "/planes/SetPlan";
const PRODUCTS_ADMIN = "/planes/GetProductAdmin";
const PRODUCT_SET = "/planes/SetProduct";
const PRODUCT_DETAIL_SET = "/planes/SetProductDetail";
const DEALER_SAVE = "Dealers/SetClient";
const DEALER_SEARCH = "Dealers/GetClient/";
const DEALER_REMOVE_PRODUCT = "Dealers/RemoveProducts/";
const DEALER_ADVERTS = "Dealers/Ads/";
const DEALER_ADVERTS_PRODUCTS = "Dealers/Ads/Products/";
const DEALER_SET_PRODUCTS = "Dealers/SetProduct";
const AWSS3_UPLOAD = "AWSS3/upload";
export default {
  admin: {
    getPlanes(id = 0) {
      /*
       *
       * @param id => buscar un único registro por id (cero para listar todos)
       *
       */
      return Axios.get(`${PLANES_ADMIN}/${id}`);
    },
    setPlan(data) {
      return Axios.post(PLANES_SET, data);
    },
    getProducts(id) {
      /*
       *
       * @param id => buscar un único registro por id
       *
       */
      typeof filter === "undefined" || filter === null ? (id = "") : id;

      return Axios.get(`${PRODUCTS_ADMIN}/${id}`);
    },
    setProduct(data) {
      return Axios.post(PRODUCT_SET, data);
    },
    SetProductDetail(data) {
      return Axios.post(PRODUCT_DETAIL_SET, data);
    },
  },
  general: {
    getPlanes(filter) {
      /*
       *
       * @param filter => puede ser 1 o 0 para filtar por planes "activos" o "inactivos"
       *
       */
      typeof filter === "undefined" || filter === null ? (filter = "") : filter;
      return Axios.get(`${PLANES}`);
    },
    getAll(query = "") {
      return Axios.get(CLIENTES + query);
    },
    put(data) {
      return Axios.put(CLIENTES, data);
    },
    dealerStatus(data) {
      return Axios.post(DEALER_STATUS, data);
    },
    saveDealer(data) {
      return Axios.post(DEALER_SAVE, data);
    },
    getDealer(idDealer) {
      return Axios.get(`${DEALER_SEARCH}${idDealer}`);
    },
    removeDealerProduct(idDealer, idDetail) {
      return Axios.post(`${DEALER_REMOVE_PRODUCT}${idDealer}/${idDetail}`);
    },
    uploadFachada(fileUpload) {
      return Axios.post(`${AWSS3_UPLOAD}`, fileUpload.file, {
        params: {
          typePath: fileUpload.typePath,
          urlFileExist: fileUpload.urlFileExist,
        },
      });
    },
  },
  asignacion: {
    getAdverts(idDealer) {
      return Axios.get(`${DEALER_ADVERTS}${idDealer}`);
    },
    getProducts(idDealer) {
      return Axios.get(`${DEALER_ADVERTS_PRODUCTS}${idDealer}`);
    },
    setProducts(data) {
      return Axios.post(DEALER_SET_PRODUCTS, data);
    },
  },
};
